import { jsx as _jsx } from "react/jsx-runtime";
import Button from './Button';
const SecondaryButton = ({ className, ...props }) => (_jsx(Button, { className: `${className} drop-shadow-xs min-w-36 rounded-md border-2 border-gray-300 bg-white px-5 py-3 font-bold text-slate-500 hover:bg-slate-100 disabled:opacity-50`, ...props }));
export default SecondaryButton;
